import { ArrowRight } from "lucide-react";
import { useEligibility } from "@/components/landing/EligibilityContext";

export const OnlineStickyBar = () => {
  const { open } = useEligibility();
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 border-t border-surfaceline bg-ink/90 px-4 pt-3 backdrop-blur-xl safe-bottom md:hidden"
      data-testid="online-sticky-bar"
    >
      <button
        onClick={open}
        data-testid="online-sticky-cta"
        className="btn-emerald shimmer-cta flex min-h-[54px] w-full items-center justify-center gap-2 rounded-full text-base font-bold text-white"
      >
        Reserve My Free Trial Seat <ArrowRight size={18} />
      </button>
    </div>
  );
};
